<div class="focus-container" cdkTrapFocus>
  <header *transloco="let t">
    <button
      app-button="icon-button"
      (click)="closeSubmenu.emit()"
      [attr.aria-label]="t('Back')"
    >
      <svg-icon key="arrow-up"></svg-icon>
    </button>

    <span>{{ category.label }}</span>

    <button
      app-button="icon-button"
      class="close-button"
      [attr.aria-label]="t('Close menu') + ' ' + category.label"
      (click)="closeMenu.emit()"
    >
      <svg-icon key="close"></svg-icon>
    </button>
  </header>

  @if (category.carousel) {
    <app-megamenu-carousel [carousel]="category.carousel"></app-megamenu-carousel>
  }

  <div class="subsections-container">
    @for (item of category.children; track item.url) {
      <app-megamenu-subsection
        [subcategory]="item"
        (linkClick)="closeMenu.emit()"
      ></app-megamenu-subsection>
    }
  </div>
</div>
